import { List } from 'immutable'
import { handleActions, combineActions } from 'redux-actions'

import * as actions from './actions'
import { DifferentActivities, DifferentActivity, Loaded } from 'store/records/differentActivities'

const handleActivitiesRequest = state => state.set('pending', true)

const handleGetFavoriteActivitiesSuccess = (state, { payload: { data = [] } }) =>
  state
    .set(
      'favorite',
      List(
        data.map(
          favoriteActivity =>
            new DifferentActivity({
              activityId: favoriteActivity && favoriteActivity.id,
              ...favoriteActivity,
            })
        )
      )
    )
    .set('pending', false)
    .setIn(['loaded', 'favorite'], true)

const handleGetFavoriteActivitiesFail = state =>
  state
    .set('favorite', List())
    .set('pending', false)
    .setIn(['loaded', 'favorite'], false)

const handleGetPreviousActivitiesSuccess = (state, { payload: { data = [] } }) =>
  state
    .set(
      'previous',
      List(
        data.map(
          previousActivity =>
            new DifferentActivity({
              activityId: previousActivity && previousActivity.id,
              ...previousActivity,
            })
        )
      )
    )
    .set('pending', false)
    .setIn(['loaded', 'previous'], true)

const handleGetPreviousActivitiesFail = state =>
  state
    .set('previous', List())
    .set('pending', false)
    .setIn(['loaded', 'previous'], false)

const handleGetUpcomingActivitiesSuccess = (state, { payload: { data = [] } }) =>
  state
    .set(
      'upcoming',
      List(
        data.map(
          upcomingActivity =>
            new DifferentActivity({
              activityId: upcomingActivity && upcomingActivity.id,
              ...upcomingActivity,
            })
        )
      )
    )
    .set('pending', false)
    .setIn(['loaded', 'upcoming'], true)

const handleGetUpcomingActivitiesFail = state =>
  state
    .set('upcoming', List())
    .set('pending', false)
    .setIn(['loaded', 'upcoming'], false)

const handleSetActivitiesLoadStatusToDefault = state => state.set('loaded', new Loaded())

const handlePendingAfterRedirect = state => state.set('pending', false)

export default handleActions(
  {
    [actions.getFavoriteActivities.success]: handleGetFavoriteActivitiesSuccess,
    [actions.getPreviousActivities.success]: handleGetPreviousActivitiesSuccess,
    [actions.getUpcomingActivities.success]: handleGetUpcomingActivitiesSuccess,
    [actions.getFavoriteActivities.fail]: handleGetFavoriteActivitiesFail,
    [actions.getPreviousActivities.fail]: handleGetPreviousActivitiesFail,
    [actions.getUpcomingActivities.fail]: handleGetUpcomingActivitiesFail,
    [actions.setActivitiesLoadStatusToDefault]: handleSetActivitiesLoadStatusToDefault,
    [actions.setFalsePendingStatus]: handlePendingAfterRedirect,
    [combineActions(
      actions.getFavoriteActivities,
      actions.getPreviousActivities,
      actions.getUpcomingActivities,
      actions.tryDifferentActivity
    )]: handleActivitiesRequest,
  },
  new DifferentActivities()
)
